import React, { useEffect } from "react";
import styled from "styled-components";
import { useNavigate } from "react-router-dom";
import { logPageView } from "../../analytics/GoogleAnalytics";

const PageContainer = styled.div`
  min-height: 100vh;
  height: auto;
  background-color: #f0f0f0;
`;

const HeaderSection = styled.div`
  padding: 20px;
  text-align: center;
`;

const BackButton = styled.button`
  background: #f0f0f0;
  color: #333;
  border: 1px solid #ccc;
  padding: 8px 16px;
  border-radius: 6px;
  font-size: 0.85rem;
  cursor: pointer;
  transition: all 0.2s ease;
  margin-bottom: 10px;

  &:hover {
    background: #e0e0e0;
  }
`;

const Title = styled.div`
  font-size: 1.5rem;
  color: #222;
  text-align: center;
  font-weight: 600;
  padding: 10px;
`;

const ContentSection = styled.div`
  max-width: 700px;
  margin: 0 auto;
  padding: 20px 24px 40px;
  color: #333;
  font-size: 0.7rem;
  line-height: 1.6;

  p {
    margin-bottom: 1rem;
  }

  a {
    color: #663399;
    text-decoration: underline;
  }

  a:hover {
    color: #4a2470;
  }

  strong {
    font-weight: 600;
  }
`;

const Section = styled.section`
  margin-bottom: 1.75rem;
`;

const SectionTitle = styled.h2`
  font-size: 0.8rem;
  font-weight: 600;
  color: #222;
  margin: 0 0 0.5rem 0;
`;

const TermsAndOwnership: React.FC = () => {
  const navigate = useNavigate();

  useEffect(() => {
    document.title = "Art of The Day – Terms and ownership";
    logPageView();
  }, []);

  return (
    <PageContainer>
      <HeaderSection>
        <BackButton onClick={() => navigate("/art-of-the-day")}>
          ← Back to AOTD
        </BackButton>
        <Title>Terms and ownership</Title>
      </HeaderSection>
      <ContentSection>
        <Section>
          <SectionTitle>1. First AOTD — proof of conceptualization</SectionTitle>
          <p>
            the concept of the Art of the Day was conceived early 2023. the first ever AOTD was created on the 11th of april, 2023. 
            </p>
            <p>
            the only proof of its existence other than this website, is an instagram
            story highlight on the profile{" "}
            <a
              href="https://instagram.com/n450s"
              target="_blank"
              rel="noreferrer"
            >
              https://instagram.com/n450s
            </a>
            . the instagram account is owned by the site creator and this instagram highlight is the only dated snapshot trace of this idea that was captured on an internet's "trusted" source. the account is
            private and will only become public in case of any valid dispute related to the AOTD.
          </p>
        </Section>
        <Section>
          <SectionTitle>2. Ownership</SectionTitle>
          <p>
            the author of each AOTD receives <strong>45%</strong> of its
            ownership; <strong>55%</strong> is attributed to the site creator.
            after 12th of january 2025, this ownership split applies when <strong>at least one emoji</strong> is used by the author to generate the AOTD.
          </p>
          <p>
            The owner needs to be able to prove the ownership of the art by providing at least 2 validation source proofs (see section 3).
          </p>
        </Section>

        <Section>
          <SectionTitle>3. Validation — sources</SectionTitle>
          <p>
            <strong>This website</strong> — the art of the day is
            published on{" "}
            <a
              href="https://n450s.com"
              target="_blank"
              rel="noreferrer"
            >
              https://n450s.com
            </a>
            . if the website is not compromised, this is the strongest proof of validation.
          </p>
          <p>
            <strong>Twitter/X</strong> — the tweet linked on each art is a second
            proof of validation. twitter is valid as a proof source for AOTDs
            from <strong>22th of september 2024</strong> onward. it cannot be used
            as validation alone; if this website and the tweet do not match, the
            art will be disputed and flagged. for the tweet to be valid, the AOTD must have been posted on  
            <a
              href="https://x.com/n450s"
              target="_blank"
              rel="noreferrer"
              >
                n450s X account
              </a>
               at the same date as the AOTD was created.
          </p>
          <p>
            <strong>Web archive (Wayback Machine)</strong> — the wayback
            snapshot is used to verify the art. it tries to fetch the website https://AOTD.n450s.com 10 mins after the AOTD every day. it is considered a valid
            source only when it has captured the AOTD without errors, and for AOTDs from{" "}
            <strong>22th of december 2025</strong> onward. (starting from that date, submission
            is automatic and the snapshot generates automatically 450 seconds
            after submission).
          </p>
          <p> 
            <strong>Instagram</strong> — the instagram story highlights of <a
              href="https://instagram.com/n450s"
              target="_blank"
              rel="noreferrer"
            >
              n450s Instagram account
            </a> can be used to verify the AOTD.
          </p>
          <p>
            <strong>Website creator verification</strong> — the website owner can verify the art by providing a proof of existence or by providing other types of proofs.
          </p>
        </Section>

        <p style={{ color: "#666", fontSize: "0.6rem", marginTop: "1rem" }}>
          last updated: 7/2/26
        </p>
      </ContentSection>
    </PageContainer>
  );
};

export default TermsAndOwnership;
